<template>
    <div class="animated fadeIn">
      <b-row>
        <b-col lg="6">
          <b-card style="min-height:450px;">
            <b-card-header> Issue info </b-card-header>
            <b-card-body style="font-size:1.3em">
              <div style="margin-bottom:8px">
                <span><b>Location:</b> {{ data.location }}, {{ data.state }} - {{ data.address }}</span>
              </div>
              <div style="margin-bottom:8px">
                <span><b>Contact:</b> {{ data.contact }}</span>
              </div>
              <div style="margin-bottom:8px">
                <span><b>Phone:</b> {{ data.phoneNumber }}</span>
              </div>
              <div style="margin-bottom:8px">
                <span><b>Company:</b> {{ data.company }} </span>
              </div>
              <div style="margin-bottom:8px">
                <span><b>Date: </b>{{ data.date }} </span>
              </div>
              <div style="margin-bottom:8px;">
                <span><b>Comment: </b>{{ data.salesComment }} </span>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col lg="6">
          <b-card style="min-height:450px;">
            <b-card-header> Edit Sale</b-card-header>
            <b-card-body>
              <b-row>
              <b-col lg="4">
                <label for="company">Company</label>
                <b-form-input id="company" v-model="company" placeholder="Company" />
              </b-col>
              <b-col lg="4">
                <label for="contactName">Contact Name</label>
                <b-form-input id="contactName" v-model="contactName" placeholder="Contact Name" />
              </b-col>
              <br /><br />
              <b-col lg="4" class="my-1">
                <label for="phoneNumber">Phone number</label>
                <b-form-input id="phoneNumber" v-model="phoneNumber" placeholder="Phone number" />
              </b-col>
              <b-col lg="4" class="my-1">
                <label for="address">Adress</label>
                <b-form-input id="address" v-model="address" placeholder="Adress" />
              </b-col>
              <b-col lg="4" class="my-1">
                <label for="city">City</label>
                <b-form-input id="city" v-model="city" placeholder="City" />
              </b-col>
              <b-col lg="2" class="my-1">
                <label for="state">State</label>
                <b-form-input id="state" v-model="state" placeholder="State" />
              </b-col>
              <b-col lg="2" class="my-1">
                <label for="zip">Zip</label>
                <b-form-input id="zip" v-model="zip" placeholder="Zip" />
              </b-col>
            
            <b-col class="col-12 my-1">
            <label for="textarea" style="color:lightgray;padding:3px">Comment</label>
              <b-form-textarea
                id="textarea"
                style="margin-bottom:10px"
                v-model="salesComment"
                placeholder="Comment"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-col>
            <b-col class="col-12 my-1">
              <label for="saleStatus" style="color:lightgray;padding:3px">Select Status</label>
              <b-form-select
                v-model="saleStatus"
                :options="saleValues"
                style="height:45px;"
                class="mb-2 selectlocation"
                value-field="value"
                text-field="text"
                id="saleStatus"
              >
              </b-form-select>
            </b-col>
          </b-row>
              <b-button
                variant="outline-primary"
                @click="updateData()"
                style="display:block; margin: auto; margin-top:25px; width:80px"
                >Update</b-button
              >
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <!-- COMMENTS -->
        <b-col lg="12">
          <b-card>
            <b-card-header> Comments </b-card-header>
            <b-card-body style="font-size:1.3em">
              <template v-for="c in comments">
                <!-- <b-col col="12" :key="c.id"  -->
                    <b-col lg="12" style="padding: 5px;">
                  <a
                    ><b>{{ c.user }}: </b> {{ c.comment }}</a
                  >
                </b-col>
              </template>
  
              <b-form-textarea
                id="textarea"
                style="margin-bottom:10px; margin-top:30px"
                v-model="comment"
                placeholder="Add new comment"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
              <b-button
                variant="outline-primary"
                @click="sendComment()"
                style="display:block; margin: auto; margin-top:25px; width:80px"
                >Send</b-button
              >
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </template>
  
  <script>
  import router from "../../router";
  import { allowedPath } from "../../shared/utils";
  
  export default {
    props: ["id"],
    data: function() {
      return {
        idParam: "",
        salesComment: "",
        comments: [],
        data: [],
        saleStatus: "",
        saleValues: [
          {
            value: "1",
            text: "Inactive existing customer"
          },
          {
            value: "2",
            text: "Active Target"
          },
          {
            value: "3",
            text: "Closed/Lost"
          },
          {
            value: "4",
            text: "Closed/Won"
          }
        ],
        comment: "",
        company: "",
        contactName: "",
        phoneNumber: "",
        address: "",
        city: "",
        state: "",
        zip: ""
      };
    },
    methods: {
      getData() {
        let params = {};
        params = {
          id: this.idParam
        };
        this.$http.get("api/fns/sales/getSale.php?", { params }).then(
          res => {
            this.data = res.data;
            this.salesComment = this.data.salesComment;
            this.saleStatus = this.data.saleStatus;
            this.comments = res.data.comments;
            this.company = this.data.company,
            this.contactName = this.data.contact,
            this.phoneNumber = this.data.phoneNumber,
            this.address = this.data.address,
            this.city = this.data.location,
            this.state = this.data.state,
            this.zip = this.data.zip
          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        );
      },
      updateData() {
        let formData = new FormData();
        formData.append("id", this.idParam);
        formData.append("comment", this.salesComment);
        formData.append("salesStatusId", this.saleStatus);
        formData.append("company", this.company);
        formData.append("contactName", this.contactName);
        formData.append("phoneNumber", this.phoneNumber);
        formData.append("address", this.address);
        formData.append("city", this.city);
        formData.append("state", this.state);
        formData.append("zip", this.zip);
        formData.append("user", localStorage.getItem("fns_full_name"));
        this.$http
          .post("api/fns/sales/updateSale.php", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          })
          .then(
            res => {
              this.getData();
            },
            err => {
              alert(err.error);
              console.log(err);
            }
          );
      },
      sendComment() {
        let formData = new FormData();
  
        formData.append("comment", this.comment);
        formData.append("user", localStorage.getItem("fns_full_name"));
        formData.append("salesId", this.idParam);
  
        this.$http
          .post("api/fns/sales/updateSalesComment.php", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          })
          .then(
            res => {
              this.comment = '';
              this.getData();
            },
            err => {
              alert(err.error);
              console.log(err);
            }
          );
      },
    },
    mounted() {
      allowedPath(
        router.currentRoute.path,
        localStorage.getItem("user_tabs"),
        localStorage.getItem("redirect_path")
      );
      this.idParam = this.id;
      this.getData();
    }
  };
  </script>
  <style>
  .selectlocation {
    background: #515b65;
    border: 1px solid black;
    color: white;
  }
  </style>
  